import { useTranslation } from 'react-i18next';
import { IconEvents } from '@components/icons/icon-events';
import { IconMapLocation } from '@components/icons/icon-map-location';
import { IconTicket } from '@components/icons/icon-ticket';

import { MagicSearchItemMedia } from './magic-search-item-media';

const SCOPES = [
  { name: 'menu:events', accepts: 'menu:magicSearchScopeEvents', Icon: IconEvents },
  { name: 'menu:magicSearchVenues', accepts: 'menu:magicSearchScopeVenues', Icon: IconMapLocation },
  { name: 'menu:magicSearchBookings', accepts: 'menu:magicSearchScopeBookings', Icon: IconTicket },
] as const;

export const MagicSearchScopes = () => {
  const { t } = useTranslation();

  return (
    <ul className='flex flex-col gap-1 p-1' data-testid='magic-search--hint'>
      {SCOPES.map(({ name, accepts, Icon }) => (
        <li key={name} className='flex items-center gap-3 px-2 py-1.5'>
          <MagicSearchItemMedia Icon={Icon} />
          <span className='w-20 shrink-0 text-subtitle-s text-secondary'>{t(name)}</span>
          <span className='min-w-0 text-body-s text-tertiary'>{t(accepts)}</span>
        </li>
      ))}
    </ul>
  );
};
